import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]

import { AdSize, MediumRectangle } from '@/common/adSizes';
import store from '@/store';
import {
  computed, onMounted, PropType, ref,
} from 'vue';
import DnsForDevelopersAd from './DnsForDevelopersAd.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NitroPayAd',
  props: {
  id: {
    type: String,
    required: true,
  },
  adSizes: {
    type: Array as PropType<Array<AdSize>>,
    default: () => [MediumRectangle],
  },
  mediaQuery: {
    type: String,
    default: undefined,
  },
  withFallback: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

/* eslint-disable @typescript-eslint/ban-ts-comment */



const showAds = computed(() => store.state.showAds);
const adsBlocked = computed(() => store.state.adsBlocked);
const selected = ref(props.adSizes.length - 1);
const cycleAds = () => {
  selected.value = (selected.value + 1) % props.adSizes.length;
};

if (!adsBlocked.value) {
  onMounted(() => {
    // @ts-ignore
    window.nitroAds.createAd(`n-${props.id}`, {
      refreshTime: 30,
      renderVisibleOnly: false,
      refreshVisibleOnly: true,
      sizes: props.adSizes,
      report: {
        enabled: false,
      },
      mediaQuery: props.mediaQuery,
    });
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `n-${__props.id}-wrapper`
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent('style'), null, {
      default: _withCtx(() => [
        _createTextVNode(" @media " + _toDisplayString(__props.mediaQuery) + " { #n-" + _toDisplayString(__props.id) + "-fallback { display: block; } } ", 1)
      ]),
      _: 1
    })),
    (__props.withFallback)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(" @media " + _toDisplayString(__props.mediaQuery) + " { #n-" + _toDisplayString(__props.id) + "-wrapper { min-height: 300px; min-width: 250px; } } ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(adsBlocked) && __props.withFallback)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: `n-${__props.id}-fallback`,
          class: "mx-auto w-[300px] h-[250px] hidden"
        }, [
          _createVNode(DnsForDevelopersAd)
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          id: `n-${__props.id}`,
          class: _normalizeClass([_unref(showAds) ? '' : 'hidden'])
        }, null, 10, _hoisted_3)),
    _createElementVNode("div", {
      id: `n-${__props.id}-box`,
      class: _normalizeClass([_unref(showAds) ? 'hidden' : '',
                  'mx-auto cursor-pointer bg-gray-300 overflow-auto font-mono',
         ]),
      onClick: cycleAds
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.adSizes, (adSize, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass([
             'ml-2',
             index === selected.value ? 'font-bold' : '',
             index === 0 ? 'mt-2' : '',
           ])
        }, _toDisplayString(adSize[0]) + " x " + _toDisplayString(adSize[1]), 3))
      }), 128))
    ], 10, _hoisted_4),
    (!_unref(showAds) && __props.adSizes.length)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('style'), { key: 3 }, {
          default: _withCtx(() => [
            _createTextVNode(" #n-" + _toDisplayString(__props.id) + "-box { display: none; width: " + _toDisplayString(__props.adSizes[selected.value][0]) + "px; height: " + _toDisplayString(__props.adSizes[selected.value][1]) + "px; } @media " + _toDisplayString(__props.mediaQuery) + " { #n-" + _toDisplayString(__props.id) + "-box { display: block; } } ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})